import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import KitActivationFlow from './KitActivationFlow';
import './ActDashboard.css';
import './KitActivationFlow.css';
import logo from '../../assets/SZALW[1].png';

const ActDashboard = ({ user, onLogout }) => {
  const [selectedKit, setSelectedKit] = useState(null);
  const [isActivating, setIsActivating] = useState(false);
  
  // --- STATE FOR DYNAMIC DATA ---
  const [userKits, setUserKits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  // --- USEEFFECT TO FETCH KITS ---
  useEffect(() => {
    if (!user?.identifier) return;

    const fetchUserKits = async () => {
      setIsLoading(true);
      setError('');
      try {
        const response = await fetch(`https://service9004.szapfs.org/api/user/${user.identifier}/kits`);
        if (!response.ok) {
          throw new Error('Could not fetch your kits. Please try again later.');
        }
        const data = await response.json();
        setUserKits(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserKits();
  }, [user?.identifier]); // Re-fetch if the user identifier changes

  const handleActivateKit = () => {
    setIsActivating(true);
  };

  const handleActivationComplete = () => {
    setIsActivating(false);
    // A page reload is a simple way to refresh the kits list after activation.
    window.location.reload();
  };

  const handleKitClick = (kit) => {
    // For now, we just log. The detail view would need more data from the API.
    console.log(`Kit ${kit.id} clicked`);
    setSelectedKit(kit);
  };

  const handleBackToList = () => {
    setSelectedKit(null);
  };
  
  const renderKitList = () => {
      if (isLoading) {
          return <div className="SACT-loading-spinner" style={{ margin: 'auto', marginTop: '50px' }}></div>;
      }
      if (error) {
          return <p className="SACT-kits-message">{error}</p>;
      }
      if (userKits.length === 0) {
          return <p className="SACT-kits-message">You have no registered kits yet.</p>;
      }
      return (
          <div className="SACT-kit-list">
            {userKits.map((kit) => (
              <div key={kit.id} className="SACT-kit-item" onClick={() => handleKitClick(kit)}>
                <div className="SACT-kit-info">
                  <span className="SACT-kit-id">Kit #{kit.id}</span>
                  <span className="SACT-kit-type">{kit.type}</span>
                </div>
                <div className="SACT-kit-status">
                  <span className={`SACT-status-badge SACT-status-${kit.statusClass}`}>{kit.status}</span>
                </div>
              </div>
            ))}
          </div>
      );
  };

  return (
    <div className="SACT-wrapper">
      <motion.div 
        className="SACT-dashboard-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <div className="SACT-dashboard-header">
        <img src={logo} alt="SZA Longevity Logo" className="SACT-logo-init-t" />
        <div className="SACT-header-actions">
            <button 
              className="SACT-btn SACT-btn-activate"
              onClick={handleActivateKit}
            >
              Activate Kit
            </button>
          </div>
        </div>

        <div className="SACT-dashboard-body">
          <div className="SACT-dashboard-left-panel">
            <div className="SACT-dashboard-welcome">
              <h2 className="SACT-dashboard-title">Welcome, {user?.First_Name || 'User'}!</h2>
              <p className="SACT-dashboard-subtitle">
                View your registered kits or activate a new one to continue your health journey.
              </p>
            </div>
          </div>

          <div className="SACT-dashboard-right-panel">
            <div className="SACT-kits-card">
              {!selectedKit ? (
                <>
                  <h3>Registered Kits</h3>
                  <div className="SACT-kits-content">
                    {renderKitList()}
                  </div>
                </>
              ) : (
                <>
                  <div className="SACT-kit-detail-header">
                    <button className="SACT-back-btn" onClick={handleBackToList}>← Back to Kits</button>
                    <h3>Kit #{selectedKit.id}</h3>
                  </div>
                  <div className="SACT-kit-detail-content">
                    <div className="SACT-kit-detail-section">
                      <h4>{selectedKit.type}</h4>
                      <p className="SACT-kit-detail-description">{selectedKit.description}</p>
                      <div className="SACT-kit-detail-status">
                        <span className={`SACT-status-badge SACT-status-${selectedKit.statusClass}`}>
                          {selectedKit.status}
                        </span>
                      </div>
                    </div>
                     <div className="SACT-kit-detail-section">
                        <h4>Activation Date</h4>
                        <p>{new Date(selectedKit.date).toLocaleDateString()}</p>
                    </div>
                    {/* The more detailed timeline would require more data from the API */}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <button 
          className="SACT-btn SACT-btn-signout"
          onClick={onLogout}
        >
          Sign Out
        </button>
      </motion.div>


      {isActivating && (
        <motion.div
          className="SACT-activation-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
            <div className='SACT-ACM-Holder'> 
          <KitActivationFlow 
            user={user} 
            onComplete={handleActivationComplete} 
          /> </div>
        </motion.div>
      )}
    </div>
  );
};

export default ActDashboard;